import React from 'react';
import { Loader2 } from 'lucide-react';
import type { T05LeadFormState } from '../../../hooks/useT05LeadForm';
import { HERO_EMAIL_ARIA_LABEL, HERO_EMAIL_PLACEHOLDER } from './t05PublicCopy';

interface T05HeroLeadFormProps {
  lead: Pick<
    T05LeadFormState,
    | 'heroEmail'
    | 'setHeroEmail'
    | 'submitLead'
    | 'isSubmitting'
    | 'leadFeedback'
    | 'leadFeedbackKind'
    | 'isLeadModalOpen'
    | 'heroFeedbackRef'
  >;
  className?: string;
  submitLabel?: string;
}

export const T05HeroLeadForm: React.FC<T05HeroLeadFormProps> = ({
  lead,
  className = 't05-hero-form reveal-up',
  submitLabel = 'Kostenlose Analyse',
}) => {
  const {
    heroEmail,
    setHeroEmail,
    submitLead,
    isSubmitting,
    leadFeedback,
    leadFeedbackKind,
    isLeadModalOpen,
    heroFeedbackRef,
  } = lead;

  return (
    <>
      <form className={className} onSubmit={submitLead} autoComplete="on">
        <div className="t05-hero-form__row">
          <input
            type="email"
            name="email"
            className="t05-hero-form__input"
            placeholder={HERO_EMAIL_PLACEHOLDER}
            value={heroEmail}
            onChange={(e) => setHeroEmail(e.target.value)}
            autoComplete="email"
            required
            aria-label={HERO_EMAIL_ARIA_LABEL}
          />
          <button type="submit" className="t05-btn t05-btn--primary" disabled={isSubmitting}>
            {isSubmitting ? <Loader2 size={18} className="animate-spin" /> : submitLabel}
          </button>
        </div>
      </form>
      {leadFeedback && !isLeadModalOpen && (
        <p
          ref={heroFeedbackRef}
          className={`t05-hero-hint t05-hero-feedback t05-hero-feedback--${leadFeedbackKind}`}
          role="status"
          aria-live="polite"
        >
          {leadFeedback}
        </p>
      )}
    </>
  );
};
